// src/components/common/Card.jsx
import React from 'react';

const Card = ({ 
  children, 
  title, 
  className = '',
  headerClassName = '',
  bodyClassName = ''
}) => {
  return (
    <div className={`bg-gray-800 rounded-lg shadow border border-gray-700 overflow-hidden ${className}`}>
      {title && (
        <div className={`px-6 py-4 border-b border-gray-700 bg-gray-900 ${headerClassName}`}>
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        </div>
      )}
      <div className={`px-6 py-4 ${bodyClassName}`}>
        {children}
      </div>
    </div>
  );
};

export default Card;